import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { changedValues } from "../../utils/changedValues";
import { editFunctionalityPointAccess } from "../../repositories/functionalityPointAccessRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";

const UpdateFunctionalityPointAccess = ({ location }) => {
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(location.state.row.Titulo);
  const [description, setDescription] = useState(location.state.row.Descricao);
  const [startDate, setStartDate] = useState(location.state.row.DataInicio);
  const [endDate, setEndDate] = useState(location.state.row.DataFim);
  const [active, setActive] = useState(location.state.row.Ativo);
  const [initialState, setInitialState] = useState({
    Titulo: location.state.row.Titulo,
    Descricao: location.state.row.Descricao,
    DataInicio: location.state.row.DataInicio,
    DataFim: location.state.row.DataFim,
    Ativo: location.state.row.Ativo,
  });
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const resultValidation = validatesNotNull([
        { value: title, key: "title" },
        { value: description, key: "description" },
        { value: startDate, key: "startDate" },
        { value: endDate, key: "endDate" },
      ]);

      if (
        startDate &&
        endDate &&
        Date.parse(startDate) >= Date.parse(endDate)
      ) {
        notify("A data fim deve ser maior que a data início.");
        resultValidation.error = true;
        resultValidation.errorsValidation.endDate = true;
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      }

      const body = changedValues({
        initial: initialState,
        current: {
          Titulo: title,
          Descricao: description,
          DataInicio: startDate,
          DataFim: endDate,
          Ativo: active,
        },
      });

      if (Object.keys(body).length < 1) return setLoading(false);

      const { data } = await editFunctionalityPointAccess({
        id: location.state.row.Id,
        body,
      });

      if (data.success) {
        setInitialState(Object.assign(initialState, body));
        notify("Registro atualizado com sucesso.", true, "info");
        goBack();
      }
    } catch (error) {
      console.error("ERROR: UpdateFunctionalityPointAccess", error);
      return setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={7}
          sm={7}
          xs={10}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={goBack} />

          <label className="title">
            Editar funcionalidade de ponto de acesso
          </label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Título*"
              autoFocus
              type="text"
              value={title}
              setValue={setTitle}
              error={errors.title}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Descrição*"
              type="text"
              value={description}
              setValue={setDescription}
              error={errors.description}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldCustom
              label="Data Início*"
              type="date"
              value={startDate}
              setValue={setStartDate}
              error={errors.startDate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldCustom
              label="Data Fim*"
              type="date"
              value={endDate}
              setValue={setEndDate}
              error={errors.endDate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <FormControlLabel
            control={
              <Switch
                checked={active}
                onChange={() => setActive((e) => !e)}
                name={active ? "Ativo" : "Inativo"}
                color="primary"
              />
            }
            label={active ? "Ativo" : "Inativo"}
          />

          <button
            id="buttonStyle"
            type="submit"
            className="btn btn-info btn-block"
          >
            Editar
          </button>
        </Grid>
      </Grid>
    </form>
  );
};

export default UpdateFunctionalityPointAccess;
